import type { ActivityCell, Issue, Repo, Stats } from "@/types/repo";

const BASE = "/api";

async function get<T>(path: string): Promise<T> {
  const res = await fetch(BASE + path, { credentials: "include" });
  if (!res.ok) throw new Error(`API ${path}: ${res.status}`);
  return res.json() as Promise<T>;
}

export async function fetchRepos(params?: {
  language?: string;
  topic?: string;
}): Promise<Repo[]> {
  const q = new URLSearchParams();
  if (params?.language) q.set("language", params.language);
  if (params?.topic) q.set("topic", params.topic);
  const qs = q.toString() ? "?" + q.toString() : "";
  return get<Repo[]>("/repos" + qs);
}

export async function fetchStats(): Promise<Stats> {
  return get<Stats>("/stats");
}

export async function fetchActivity(params?: {
  repo_id?: number;
  year?: number;
}): Promise<ActivityCell[]> {
  const q = new URLSearchParams();
  if (params?.repo_id != null) q.set("repo_id", String(params.repo_id));
  if (params?.year) q.set("year", String(params.year));
  const qs = q.toString() ? "?" + q.toString() : "";
  return get<ActivityCell[]>("/activity" + qs);
}

export async function fetchIssues(params?: {
  repo_id?: number;
  difficulty?: string;
}): Promise<Issue[]> {
  const q = new URLSearchParams();
  if (params?.repo_id != null) q.set("repo_id", String(params.repo_id));
  if (params?.difficulty) q.set("difficulty", params.difficulty);
  const qs = q.toString() ? "?" + q.toString() : "";
  return get<Issue[]>("/issues" + qs);
}
